import React from "react";
import {Link} from "react-router-dom";

function PastPFDateAndDesc({...props}) {
    return (
        <div>
            Winchester Porchfest 2025 was held on Saturday June 14. Here are some
            of the <Link to="/last-porchfest" reloadDocument="true">moments</Link> from
            that day.
        </div>
    );
}

export default PastPFDateAndDesc;